import Vue from 'vue';
import Vuex from 'vuex';
import config from 'BRAND/config';
import core from '@/store/modules/core';
import account from '@/store/modules/account';
import variable from '@/store/modules/variable';
import locale from '@/store/modules/locale';
import rule from '@/store/modules/rule';
import query from '@/store/modules/query';
import permissions from '@/store/modules/permissions';
import group from '@/store/modules/group';
import groupUsers from '@/store/modules/groupUsers';
import groupPermissions from '@/store/modules/groupPermissions';
import user from '@/store/modules/user';
import explorerTimeline from '@/store/modules/explorerTimeline';
import explorerCorrelation from '@/store/modules/explorerCorrelation';
import tag from '@/store/modules/tag';
import currentStatus from '@/store/modules/currentStatus';
import category from '@/store/modules/category';
import cacheManagement from '@/store/modules/cacheManagement';
import chatbot from '@/store/modules/chatbot';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    core,
    locale,
    account,
    variable,
    rule,
    query,
    permissions,
    group,
    groupUsers,
    groupPermissions,
    user,
    explorerTimeline,
    explorerCorrelation,
    tag,
    currentStatus,
    category,
    cacheManagement,
    chatbot,
    ...(config.modules === undefined ? {} : config.modules)
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js